import { useContext, useMemo } from 'react'
import GlobalContext, { GlobalContextType } from '../context/GlobalContext'

export type FieldType = Omit<GlobalContextType, 'reset'>

export type ReturnProps<Field extends keyof FieldType> = {
    loaded: boolean
    entities?: FieldType[Field]
}

export default function useGlobalContext<Field extends keyof FieldType>(field: Field): ReturnProps<Field> {
    const globalContext = useContext(GlobalContext)

    const entities = useMemo(() => {
        return (globalContext?.[field] || []) as FieldType[Field]
    }, [globalContext, field])

    return { loaded: globalContext?.loaded || false, entities }
}
